module.exports = __webpack_public_path__ + "img/phoneEle.d72249c4.svg";